import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from "../locales/en/en.json";
import mr from "../locales/mr/mr.json";
import hi from "../locales/hi/hi.json";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: en,
            },
            mr: {
                translation: mr,
            },
            hi: {
                translation: hi,
            },
        },
        lng: 'en', // default language
        fallbackLng: 'en', // fallback language if translation is missing
        interpolation: {
            escapeValue: false, // React already escapes XSS
        },
    });

export default i18n;
